import ReactLoading from "react-loading";

const LoadingBars = (props) => {
  const type = props.type;
  const color = props.color;
  return (
    <ReactLoading type={type} color={color} height={"20%"} width={"20%"} />
  );
};

export default LoadingBars;
